var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "显示类型" } },
        [
          _c(
            "el-select",
            {
              staticClass: "setting-date-type",
              model: {
                value: _vm.dateType,
                callback: function($$v) {
                  _vm.dateType = $$v
                },
                expression: "dateType"
              }
            },
            [
              _c("el-option", { attrs: { value: "year", label: "年历" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "month", label: "月历" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "date", label: "日历" } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-550ad08c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550ad08c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingDateType.vue
// module id = null
// module chunks = 